import { ClaimData, InsuranceUsage } from './ClaimData'
import { SyncInsuranceMemberPayload } from './ClaimRecord'
import { ProviderType } from './Insurer'

export enum InsuranceMemberStep {
  INIT = 'INIT',
  FIND_MEMBER = 'FIND_MEMBER',
  SYNC_INSURANCE = 'SYNC_INSURANCE',
  MEMBER_FOUND = 'MEMBER_FOUND',
  RESTRICTED = 'RESTRICTED',
  UNKNOWN = 'UNKNOWN',
}

export type SyncInitResult = {
  claimRecordId: string
}

export type InsuranceMemberStepPayload = {
  step: InsuranceMemberStep
  patchData?: ClaimData
  syncInit?: () => Promise<SyncInitResult>
  syncPayload?: SyncInsuranceMemberPayload
}

export type InsuranceMemberStepState = InsuranceMemberStepPayload

export type InsuranceMemberInsurerSelection = {
  insurerId?: string
  providerType?: ProviderType
}

export type ChangeInsuranceStatusRequest = {
  claimRecordId: string
  useInsuranceStatus: InsuranceUsage
}
